import { ApolloError, useMutation } from '@apollo/client'
import { PromoteDemotContentItem } from 'api/graphQL/mutations/projectProductFamily.mutations'
import { handleFetchError } from 'components/WorkspaceEditor/api/utils'

export const usePromoteDemoteContentMutation = () => {
    const [promoteDemoteContentItem] = useMutation(PromoteDemotContentItem, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            // TODO: handle the response
        },
        onError: (error: ApolloError) =>
            handleFetchError(error, 'WorkspaceEditor-promoteDemoteContentItem'),
    })

    return { promoteDemoteContentItem }
}
